import styled, { css } from "styled-components";

const styles = {
  container: {
    getInTouch: css`
      flex: 1;
      background-color: ${({ theme }) => theme.colors.lightGray1};
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    `,
  },
  formWrapper: {
    getInTouch: css`
      padding-left: ${({ theme }) =>
        theme.layout.content.paddingHorizontal.desktop}px;
      padding-right: ${({ theme }) =>
        theme.layout.content.paddingHorizontal.desktop}px;
      padding-top: 35px;
      padding-bottom: 35px;

      @media only screen and (max-width: 560px) {
        padding-left: ${({ theme }) =>
          theme.layout.content.paddingHorizontal.mobile}px;
        padding-right: ${({ theme }) =>
          theme.layout.content.paddingHorizontal.mobile}px;
        padding-top: 22px;
      }
    `,
  },
  contactFormWrap: {
    getInTouch: css`
      padding-top: ${({ theme }) => theme.spacings.spacing_s};
      margin-left: -${({ theme }) => theme.spacings.spacing_xs};
      margin-right: -${({ theme }) => theme.spacings.spacing_xs};
    `,
  },
};

export const Container = styled.div`
  ${styles.container.getInTouch}
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const FormWrapper = styled.div`
  ${styles.formWrapper.getInTouch}
`;

export const Title = styled.div`
  ${({ theme }) => theme.textStyles.titleSmall2};
`;

export const Summary = styled.div`
  ${({ theme }) => theme.textStyles.titleSmall2};
  font-size: 14px;
  text-align: left;
  max-width: 357px;
  line-height: 14px;
`;

export const ContactFormWrap = styled.div`
  ${styles.contactFormWrap.getInTouch}
`;

export const ElementWrap = styled.div`
  padding-bottom: ${({ theme, pbottom }) =>
    pbottom ? pbottom : theme.spacings.spacing_xs};
  padding-right: ${({ theme, pright }) =>
    pright ? pright : theme.spacings.spacing_xs};
  padding-left: ${({ theme, pleft }) =>
    pleft ? pleft : theme.spacings.spacing_xs};
  ${({ ptop }) => ptop && `padding-top: ${ptop}`};
  width: ${({ width }) => (width ? width : "100%")};
`;

export const InlineElements = styled.div`
  display: flex;
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  @media only screen and (max-width: 560px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
